import React from "react";
import { AlertTriangle } from "lucide-react";
import { useMode } from "../context/ModeContext";

// Renders a review warning band, only in Internal Review Mode.
export function ReviewWarning({ children, className = "" }) {
  const { isInternal } = useMode();
  if (!isInternal) return null;
  return (
    <div
      data-testid="review-warning"
      className={`flex items-start gap-2 border border-[rgba(239,68,68,0.3)] bg-[rgba(239,68,68,0.08)] px-3 py-2 text-xs text-[#FCA5A5] rounded-none ${className}`}
    >
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
      <span className="font-mono-data leading-relaxed">{children}</span>
    </div>
  );
}
